import React, { useEffect } from "react"
import AppNavigation from "../../Navigations/AppNavigation"
import { NavigationContainer } from "@react-navigation/native"

import Toast from "react-native-toast-message"
import { useRecoilValue } from "recoil"
import { globalLoadingVisibleAtom } from "@Recoil/Atom/globalLoadingAtom"
import { GlobalLoading } from "@Screens/GlobalLoading/GlobalLoading"
import { useNotifications } from "../../Hooks/useNotifications"

export function AppRoot() {
    const loading = useRecoilValue(globalLoadingVisibleAtom)
    const { fetchPushNotificationToken } = useNotifications()

    useEffect(() => {
        fetchPushNotificationToken()
    }, [])

    return (
        <NavigationContainer>
            <AppNavigation />
            <Toast />
            {loading && <GlobalLoading />}
        </NavigationContainer>
    )
}
